module.exports = __webpack_public_path__ + "static/media/microsoft-edge-logo.db6bd173.svg";